// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog-custom-class-body-div[data-v-2e8ebd4b] {\n  max-height: calc(85vh - 120px);\n  overflow-y: scroll;\n}\n[data-v-2e8ebd4b] .bj-page .el-form-item__label {\n  display: none;\n}", ""]);
// Exports
module.exports = exports;
